import React, { useState } from "react";
import ReactCanvasPaint from 'react-canvas-paint';
import "./Fun.css";

const Fun = () => {
    const [drawings, setDrawings] = useState([]);
    let descriptionDrawing = "";

    // const addDescription = () => {
    //     const description = prompt("Enter a description for your drawing:");
    //     if (description) {
    //         alert(`Description added: ${description}`);
    //         descriptionDrawing = description.valueOf();
    //     }
    // };

    const saveDrawing = () => {
        setTimeout(() => {
            const canvasElement = document.querySelector('canvas');
            
            if (canvasElement) {
                const imageData = canvasElement.toDataURL('image/png');
                setDrawings([...drawings, {
                    id: Date.now(),
                    data: imageData,
                    date: new Date().toLocaleString(),
                    description: descriptionDrawing,
                }]);
            } else {
                console.error('Canvas element not found');
            }
        }, 100);
    };

    const deleteDrawing = (id) => {
        setDrawings(drawings.filter(drawing => drawing.id !== id));
    };

    const clearCanvas = () => {
        const canvasElement = document.querySelector('canvas');
        
        if (canvasElement) {
            const ctx = canvasElement.getContext('2d');
            ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        }
    };

  

    return (
        <div className="fun-container">
            <h1>Drawing Fun</h1>
            <p>Create your own drawings and save them to the gallery below! This is a WIP - trying to figure out what I want to do with this.</p>
            
            <div className="canvas-section">
                <ReactCanvasPaint 
                    width={600}
                    height={400}
                    className="canvas-paint"
                />
                <div className="canvas-controls">
                    <button onClick={saveDrawing} className="btn-save">Save Drawing</button>
                    <button onClick={clearCanvas} className="btn-clear">Clear Canvas</button>
                    {/* <button onClick={addDescription} className="btn-add-desc">Add Description</button> */}
                </div>
            </div>

            <div className="gallery-section">
                <h2>Gallery ({drawings.length})</h2>
                <div className="gallery-grid">
                    {drawings.length === 0 ? (
                        <p className="empty-message">No drawings yet. Create and save your first drawing!</p>
                    ) : (
                        drawings.map((drawing) => (
                            <div key={drawing.id} className="gallery-item">
                                <img src={drawing.data} alt={`Drawing from ${drawing.date}`} />
                                <div className="gallery-item-info">
                                    <span className="drawing-date">{drawing.date}</span>
                                    <span className="drawing-description">{drawing.descriptionDrawing}</span>
                                    <button 
                                        onClick={() => deleteDrawing(drawing.id)} 
                                        className="btn-delete"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Fun;